export const isClickAndCollectEnabled = (
  isClickAndCollectFeatureEnabled?: boolean,
  enableClickAndCollect?: boolean,
): boolean =>
  (isClickAndCollectFeatureEnabled && enableClickAndCollect) || false
